import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getPagingProfileController from './getPagingProfileController.js'
import _module from 'module.js'
import _ from 'lodash'

let getPagingProfileComponent = _.cloneDeep(getJrnDefaultComponent)
getPagingProfileComponent.controller = getPagingProfileController

_module.component('getPagingProfile', getPagingProfileComponent)
